
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UboDeclarationRequest,
  UboDeclarationResponse,
  UboResource,
} from '../models';
import {
    UboDeclarationRequestFromJSON,
    UboDeclarationRequestToJSON,
    UboDeclarationResponseFromJSON,
    UboDeclarationResponseToJSON,
    UboResourceFromJSON,
    UboResourceToJSON,
} from '../models';

export interface CompanyUboRequest {
    companyId: string;
}

export interface GetUboRequest {
    companyId: string;
}

export interface SaveUboRequest {
    companyId: string;
    uboDeclarationRequest: UboDeclarationRequest;
}

/**
 * 
 */
export class CompanyUboApi extends runtime.BaseAPI {

    /**
     * render UBO declaration for company
          */
    async companyUboRaw(requestParameters: CompanyUboRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<UboDeclarationResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling companyUbo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<UboDeclarationResponse>({
            path: `/compliance/api/company/{companyId}/ubo`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=UboDeclarationResponseFromJSON(response._data); }
        return response;
    }

    /**
     * render UBO declaration for company
          */
    async companyUbo(requestParameters: CompanyUboRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<UboDeclarationResponse> {
        const response = await this.companyUboRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getUboRaw(requestParameters: GetUboRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<UboResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getUbo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<UboResource>({
            path: `/compliance/api/company/{companyId}/ubo-resource`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=UboResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getUbo(requestParameters: GetUboRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<UboResource> {
        const response = await this.getUboRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async saveUboRaw(requestParameters: SaveUboRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling saveUbo().'
            );
        }

        if (requestParameters['uboDeclarationRequest'] == null) {
            throw new runtime.RequiredError(
                'uboDeclarationRequest',
                'Required parameter "uboDeclarationRequest" was null or undefined when calling saveUbo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/company/{companyId}/ubo-resource`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UboDeclarationRequestToJSON(requestParameters['uboDeclarationRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async saveUbo(requestParameters: SaveUboRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.saveUboRaw(requestParameters, initOverrides);
    }

}
